/* eslint-disable max-len */

// Polyfills
import 'core-js';
import 'unfetch/polyfill';
import './utils/stringRepeatPolyfill';

// Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter as Router } from 'react-router-dom';
import { createGenerateClassName } from 'react-jss';
import JssProvider from 'react-jss/lib/JssProvider';

import {
	cookiesHelper,
	AppProvider,
	SnackbarsProvider,
	Snackbar,
} from 'modules/utils';
import { Toast } from '@lavu-pos/lavu-react-components';
import TagManager from 'react-gtm-module';
import { client } from './setup';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import { getCP3Env } from './CP3Config';

// eslint-disable-next-line import/no-named-as-default
import App from './App';
import 'normalize.css';
import './vendorStyles';
import './index.css';

const tagManagerArgs = {
	gtmId: getCP3Env('REACT_APP_GOOGLE_TAG_MANAGER_ID'),
	auth: getCP3Env('REACT_APP_GTM_AUTH_ID'),
	preview: getCP3Env('REACT_APP_GTM_PREVIEW'),
};

TagManager.initialize(tagManagerArgs);
const phpSessId = cookiesHelper.get('PHPSESSID');

if (phpSessId === 'null') {
	cookiesHelper.remove('PHPSESSID');
}

const generateClassName = createGenerateClassName();

// The ApolloProvider is the integration layer between the Apollo store
// (ApolloClient) and React - it provides data to our React application.
// It is a React component to which we pass a reference to the client as
// a prop.
ReactDOM.render(
	<ApolloProvider client={client}>
		{/* Remove this Toast component, utils, and the react-toastify package once we replace all sections that use it with Snackbars */}
		<Toast />

		<SnackbarsProvider>
			<Snackbar elementId="snackbar" />

			<Router>
				<AppProvider>
					<JssProvider generateClassName={generateClassName}>
						<App />
					</JssProvider>
				</AppProvider>
			</Router>
		</SnackbarsProvider>
	</ApolloProvider>,
	document.getElementById('root')
);

// unregister service workers
unregisterServiceWorker();
